export const Y_WEBSOCK_CONNECTED = 'Y_WEBSOCK_CONNECTED';
export const Y_WEBSOCK_DISCONNECTED = 'Y_WEBSOCK_DISCONNECTED';
export const Y_WEBSOCK_DUPLICATED = 'Y_WEBSOCK_DUPLICATED';
export const SWITCH_FLAG = 'SWITCH_FLAG';

export function yWebsockConnected() {
    return {
        type: Y_WEBSOCK_CONNECTED,
    };
}

export function yWebsockDisconnected() {
    return {
        type: Y_WEBSOCK_DISCONNECTED,
    };
}

export function yWebsockDuplicated() {
    return {
        type: Y_WEBSOCK_DUPLICATED,
    };
}

export function switchFlag() {
    return {
        type: SWITCH_FLAG,
    };
}

